
import moment from 'moment/moment'

export default {
  name: 'EventCardSmall',
  props: {
    time: {
      type: String,
      required: true
    },

    event: {
      type: Object,
      required: true
    }
  },

  computed: {
    eventTeacherGroups() {
      if (
        this.event.userRole === 'teacher' &&
        this.event?.extra?.groups?.length > 0
      ) {
        const text = this.event?.extra?.groups?.length > 1 ? 'Группы' : 'Группа'

        return `${text}: ${this.event?.extra?.groups.join(', ')}`
      }

      return null
    },

    isHomework() {
      return this.event?.type?.slug === 'homework'
    },

    isEventPast() {
      const startTime = this.event?.period?.from
      if (startTime) {
        return moment(startTime).add(2, 'hours').isBefore(moment())
      }

      return this.event?.status === 'done'
    },

    eventDot() {
      if (this.event.type.slug === 'lesson') {
        return 'lesson'
      }

      if (this.event.type.slug === 'event') {
        return 'recommend'
      }

      if (this.isHomework) {
        return 'homework'
      }

      return 'lesson'
    }
  }
}
